// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__RAS5X","footer":"ModalInfo_footer__EAHeb"};